import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Tabs } from "antd";
import OfferServiceList from "./OfferServiceManagement/OfferServiceList";
import ProductList from "./ProductManagement/ProductList";

const AdminManagement = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Tab configuration
  const tabs = [
    {
      key: "products",
      label: "Sản phẩm",
      children: <ProductList />,
    },
    {
      key: "offer-services",
      label: "Ưu đãi & Dịch vụ",
      children: <OfferServiceList />,
    },
  ];

  // Lấy giá trị tab từ query parameter, mặc định là "product"
  const params = new URLSearchParams(location.search);
  const currentTab = params.get("tab") || "products";

  // Xử lý khi tab thay đổi
  const handleTabChange = (key) => {
    navigate(`/admin/management?tab=${key}`);
  };

  return (
    <Tabs
      type="card"
      activeKey={currentTab}
      onChange={handleTabChange}
      items={tabs}
      className="mx-4 mt-24"
    />
  );
};

export default AdminManagement;
